$(document).ready(function() {
	
	$('.smooth-link').click(function() {
		
		var link = $(this).attr('href');
		
		$('html, body').animate({
			scrollTop: $(link).offset().top - 71}, 1000);
		return false;	
	});
});